import React from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

export class CostShareWaiverListener extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      executing: false,
    };
  }

  componentDidUpdate() {
    this.populateWaiverRequested();
  }

  componentDidMount() {
    this.populateWaiverRequested();
  }

  populateWaiverRequested() {
    const {
      applyForWaiver,
      waiverType,
      costShareInformation,
      saveEntityData,
      typeMapping,
      applicationLoading,
      awardRecLoading,
    } = this.props;

    const waiverTypeDependency = !!_.find(
      this.props.dependencies,
      (dep) => dep.waiverType
    );
    if (
      !this.state.executing &&
      _.get(costShareInformation, 'waiverRequested') === undefined &&
      applicationLoading === false &&
      awardRecLoading === false
    ) {
      let costShareInformation = {};

      if (waiverTypeDependency) {
        let costShareInformation = {
          waivers: {},
        };

        const mappedTypes = _.get(typeMapping, waiverType, []);

        _.forEach(mappedTypes, (type) => {
          costShareInformation.waivers[type] = true;
        });

        costShareInformation.waiverRequested = applyForWaiver;

        saveEntityData(
          'context.awardRecommendation.payload.grantsManagement.costShareInformation',
          'awardRecommendation',
          costShareInformation
        );
      } else {
        costShareInformation.waiverRequested = applyForWaiver;

        saveEntityData(
          'context.awardRecommendation.payload.grantsManagement.costShareInformation',
          'awardRecommendation',
          costShareInformation
        );
      }
    }
  }
  render() {
    return null;
  }
}

export default connectDynamic(CostShareWaiverListener);
